<template>
  <teleport v-if="widget" :to="'#' + teleport">
    <div class="orm-offersslider orm-relative">
      <Slider
        v-if="offers"
        :images="offers"
        :autoplay="true"
        :intervall="10000"
        ratio="16/8"
        :arrows="false"
        :controlls-fade="false"
        @setOffer="setOffer"
      />
      <ModalPLZ
        v-if="showModal"
        :noCarfilter="true"
        :car="null"
        @cancel="cancel()"
      />
    </div>
  </teleport>
</template>

<script>
import { defineComponent } from "vue";
import store from "@/store";
import Slider from "@/components/ui/offers-slider.vue";
import ModalPLZ from "@/components/modals/modal-stationtimeselect-plz.vue"; /* webpackChunkName: 'modalStationtimeselectPlz.chunk' */

export default defineComponent({
  name: "OffersSlider",
  components: { Slider, ModalPLZ },
  data() {
    return {
      offers: null,
      demo: process.env.VUE_APP_DEMO,
      showModal: false,
      selectedOffer: null,
    };
  },
  async created() {
    // console.log(
    //   "angebote",
    //   store.getters["ORMgeneral/GET_MODULE"]("ORM_ANGEBOTE"),
    //   process.env.VUE_APP_OFFERS
    // );
    if (
      store.getters["ORMgeneral/GET_MODULE"]("ORM_ANGEBOTE") == "J" &&
      process.env.VUE_APP_OFFERS == "true"
    ) {
      console.log("angebote -yes");
      await store.dispatch("offers/SET_OFFERS");
      this.offers = store.getters["offers/GET_OFFERS"];
    }
  },
  setup() {
    const teleport = "crentOffersSliderPLZ";
    let widget = false;
    const myEle = document.getElementById(teleport);

    if (myEle !== null) {
      widget = true;
    }
    return {
      widget,
      teleport,
      // offers,
    };
  },
  methods: {
    setOffer(offer) {
      this.showModal = true;
      this.selectedOffer = offer.id;
    },
  },
});
</script>
